import { useNavigate } from 'react-router-dom';
import useAppCaching from './useAppCaching';

export default function usePlacesMetaOS(): void {
    const navigate = useNavigate();

    useAppCaching(navigate);
}
